<app-header></app-header><div class="container">
  <div class="breadcrumbs mt-4">
    <div routerLink="/">Главная</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/">Экспертиза промышленной безопасности</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/expertkltp">Проведение экспертизы промышленной безопасности (ЭПБ)</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/expprombez/expertdecl">Экспертиза промышленной безопасности сосудов, работающих под давлением</div>

  </div>
  <div class="row">
    <h1 class="w-100 mt-70">Экспертиза промышленной безопасности сосудов, работающих под давлением
    </h1>
    <ul class="link-arrow">
      <li>- В сжатые сроки</li>
      <li>- В Москве и в регионах</li>
      <li>- Большой опыт</li>
      <li>- Паспортизация</li>
    </ul>

    <p>Оборудование и <strong>сосуды, работающие под избыточным давлением более 0,07 МПа или при температуре нагрева воды и иных эксплуатируемых жидкостей более 115&deg;С</strong> (Приказ Ростехнадзора от 30 ноября 2020 года № 471) &ndash; являются одним из признаков опасности на опасном производственном объекте.</p>

    <p>Эпб сосуда под давлением на опасном производственном объекте проводится в соответствии с Федеральным законом от 21.07.1997 № 116-ФЗ.</p>

    <h2>Наши специалисты:</h2>
    <ul class="marked ml-50">
      <li>Идентифицируют любые опасные производственные объекты</li>
      <li>Проводят экспертизу промышленной безопасности</li>
      <li>Содействуют в регистрации или во внесении изменений в государственный реестр</li>
      <li>Консультируют по вопросам ввода оборудования в эксплуатацию и постановке его на учет в Ростехнадзоре</li>
    </ul>
    <app-recall-form heading="Интересует экспертиза промышленной безопасности сосудов, работающих под давлением и нет времени изучать детали? Напишите Ваш вопрос, и наши специалисты дадут необходимые разъяснения."></app-recall-form>
    <h2>Экспертиза сосудов, работающих под давлением, потребуется:</h2>

    <ul class="marked ml-50">
      <li>в случае отсутствия сертификата перед первым применением сосуда или оборудования, работающего под давлением, на опасном производственном объекте;</li>
      <li>по окончании срока его эксплуатации или при превышении максимального числа циклов нагрузки;</li>
      <li>при отсутствии данных о допустимых сроках эксплуатации в технической и проектной документации;</li>
      <li>в случае ремонта с изменением конструкции и пр., в т.ч. произведенного в результате аварий и инцидентов на опасном производственном объекте.</li>
    </ul>

    <p>Сосуды и устройства, работающие под избыточным давлением, должны отвечать <strong>Федеральным нормам и правилам в области промышленной безопасности &quot;Правила промышленной безопасности при использовании оборудования, работающего под избыточным давлением&quot;, утвержденным приказом Ростехнадзора от 15 декабря 2020 года № 536</strong> и содержащим требования к их проектированию, строительству, установке, размещению, вводу в эксплуатацию, постановке на учет и дальнейшей безопасной эксплуатации.</p>

    <p><strong>Специалисты ООО &laquo;Протос Экспертиза&raquo; имеют достаточную квалификацию и опыт, позволяющие оказывать услуги в сфере промышленной безопасности, в том числе проводить экспертизу и разрабатывать техническую документацию, в том числе паспорт на оборудование. Стоимость услуг рассчитывается индивидуально.</strong></p>
    <app-atomka-calc heading="Получить консультацию и рассчитать стоимость ЭПБ" class="w-100"></app-atomka-calc>
    <app-reviews-block class="w-100"></app-reviews-block>
  </div>
</div>
<app-footer></app-footer>
